import React from 'react';
import {
    List, Datagrid, TextField, DateField, NumberField,
    BooleanField, EditButton, ImageField, RichTextField
} from 'react-admin';

export const QuestionOptionList = props => (
    <List { ...props }>
        <Datagrid rowClick="show">
            <NumberField source="optionnumber" label="Option Number" />
            <TextField source="optiontitle" label="Option Title" />
            <RichTextField source="optiontext" label="Option Text" />
            <ImageField source="optionimage" label="Option Image" />
            <BooleanField source="iscorrect" label="Is Correct" />
            <EditButton />
        </Datagrid>
    </List>
);